module.exports = __webpack_public_path__ + "static/media/lisa-icon.092434a4.png";